// Firebase SDK removed - all operations now go through Worker
// This file is kept for compatibility but Firebase SDK is not initialized

// import { initializeApp } from 'firebase/app';
// import { getAuth } from 'firebase/auth';
// import { getFirestore } from 'firebase/firestore';
// import { getStorage } from 'firebase/storage';
// import { getFunctions } from 'firebase/functions';
// import { getDatabase } from 'firebase/database';

// const firebaseConfig = {
//   apiKey: "AIzaSyDWUrQAfOr_yL9AMnHuTs_Xmf_a6UBOdu0",
//   authDomain: "dermowise.firebaseapp.com",
//   projectId: "dermowise",
//   storageBucket: "dermowise.firebasestorage.app",
//   messagingSenderId: "860695301129",
//   appId: "1:860695301129:web:03729a9300260d8a8a7cd8",
//   measurementId: "G-KSP1V0RHQ6"
// };

// const app = initializeApp(firebaseConfig);
// export const auth = getAuth(app);
// export const db = getFirestore(app);
// export const storage = getStorage(app);
// export const functions = getFunctions(app);
// export const realtimeDb = getDatabase(app);
// export default app;

// Dummy exports for compatibility (will cause errors if used)
export const auth = null;
export const db = null;
export const storage = null;
export const functions = null;
export const realtimeDb = null;
export default null; 